import { createProductsStore } from '@forest/paywall-core'
import type { Products } from '@forest/native-services'

export const $products = createProductsStore<Products>()

export function setProducts(products: Products) {
  $products.set(products)
}
